/* src/app/location-users/add-location-users/new-user-queue/queue-user-modal/queue-user-modal.component.scss */
.cancel {
  padding-left: 30px;
  padding-bottom: 20px;
  padding-right: 10px;
}
.modal-header {
  border-bottom: none;
  padding-bottom: 0;
}
.modal-body {
  padding-bottom: 0;
}
.modal-body,
.modal-footer {
  padding-right: 40px;
}
.modal-footer {
  padding-top: 0;
  padding-bottom: 10px;
  border-top: none;
}
.btn {
  margin-top: 28px;
  height: 36px;
  border-radius: 100px;
  border: 0;
  padding-right: 28px;
  padding-left: 28px;
}
.btn-green {
  color: white;
  background-color: #00857D;
}
.btn-white {
  color: #00857D;
  background-color: white;
  border: 1px solid #00857D;
}
/*# sourceMappingURL=queue-user-modal.component.css.map */
